import React from 'react';
import { Helmet } from 'react-helmet';
import pageDescriptions from './pageDescriptions.json';

export type PageMetaRoute = keyof typeof pageDescriptions;

interface Props {
  route: PageMetaRoute;
}

/**
 * Overrides the generic description from public/index.html with a per-route one.
 * Covers client-side navigation only - crawlers reading the raw HTML are served
 * pre-built copies of index.html by scripts/postbuild-meta.js, which takes its
 * descriptions from the same pageDescriptions.json.
 */
export const PageMeta: React.FC<Props> = ({ route }) => (
  <Helmet>
    <meta name="description" content={pageDescriptions[route]} />
  </Helmet>
);
